import { connect } from 'react-redux'
import { makeConditionSelector } from 'selectors/feature/conditions'
import {
  makeConditionSimulationSelector,
  getTimerSimulationValueByUri,
} from 'selectors/feature/simulation'
import {
  updateSimulatedValue,
  resetSimulatedValue,
} from 'actions/feature/simulation'
import { getCanIdFromCondition } from 'utils/simulation'
import ConditionSimulator from './ConditionSimulator'

const makeMapStateToProps = () => {
  const conditionSelector = makeConditionSelector()
  const simulationSelector = makeConditionSimulationSelector()

  const mapStateToProps = (state, ownProps) => {
    const { uri } = ownProps
    const condition = conditionSelector(state, { queryUri: uri })
    const simulation = simulationSelector(state, { queryUri: uri })

    const current =
      condition.refQueryUri &&
      getTimerSimulationValueByUri(state, { queryUri: condition.refQueryUri })

    return {
      current,
      ...condition,
      ...simulation,
    }
  }

  return mapStateToProps
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleUpdateSimulatedValue: (value, uri) => {
    if (value && value.target) {
      dispatch(updateSimulatedValue(uri, value.target.value))
      return
    }
    dispatch(updateSimulatedValue(uri, value))
  },
  resetSimulatedValue: (uri) => dispatch(resetSimulatedValue(uri)),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { signal } = stateProps
  // simulated can id requires start bit to differentiate from other simulated can messages
  const dependencyKey = signal || getCanIdFromCondition(stateProps)
  return {
    ...stateProps,
    ...ownProps,
    handleUpdateSimulatedValue: (value) =>
      dispatchProps.handleUpdateSimulatedValue(value, dependencyKey),
    resetSimulatedValue: () => dispatchProps.resetSimulatedValue(dependencyKey),
  }
}

const connected = connect(
  makeMapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ConditionSimulator)

export default connected
